import { Typography } from '@sanlam-glacier/app-common/components';
import clsx from 'clsx';
import styles from '../../TopBar.module.scss';

interface UserContextCardProps {
  firstName: string;
  surname: string;
  selectUser: () => void;
  userCode: string | undefined;
  isSelected: boolean;
}

export const UserContextCard = ({
  firstName,
  userCode,
  surname,
  selectUser,
  isSelected
}: UserContextCardProps) => {
  const displayCode = userCode ?? '';
  return (
    <div
      className={`${clsx(styles.switchProfileItem, styles.contextMenuBaseSidePadding, styles.menuItemWithIcon)}  ${isSelected ? styles.selected : ''}`}
      onClick={() => selectUser()}
    >
      <div>
        <Typography
          variant={Typography.VARIANT.B2}
          weight={Typography.WEIGHT.NORMAL}
          color={Typography.COLOR.INHERIT}
        >
          {displayCode}
        </Typography>
        <Typography
          variant={Typography.VARIANT.B3}
          weight={Typography.WEIGHT.NORMAL}
          color={Typography.COLOR.INHERIT}
        >
          {firstName} {surname}
        </Typography>
      </div>
    </div>
  );
};
